// utils/statusUtils.js

export const getStatusColor = (statusId) => {
  switch (statusId) {
    case 1: // Created
      return "bg-gray-400 text-gray-100";
    case 2: // Assigned
      return "bg-blue-400 text-blue-100";
    case 3: // In Progress
      return "bg-yellow-500 text-yellow-900";
    case 4: // Submitted
      return "bg-indigo-500 text-indigo-100";
    case 5: // Being Reviewed
      return "bg-purple-500 text-purple-100";
    case 6: // Approved
      return "bg-green-500 text-green-100";
    case 7: // Rejected
      return "bg-red-500 text-red-100";
    case 8: // Resent
      return "bg-orange-500 text-orange-900";
    default:
      return "bg-gray-300 text-gray-100";
  }
};

// You can also export the getStatusText function here if you want it to be reusable
export const getStatusText = (statusId) => {
  switch (statusId) {
    case 1:
      return "Created";
    case 2:
      return "Assigned";
    case 3:
      return "In Progress";
    case 4:
      return "Submitted";
    case 5:
      return "Being Reviewed";
    case 6:
      return "Approved";
    case 7:
      return "Rejected";
    case 8:
      return "Resent";
    default:
      return "Unknown Status";
  }
};
